export const MABLE_CLIENT_FEES = {
  legacyFee: '5%',
  currentFee: '7.95%',
} as const;

export const MABLE_SUPPORT_PROVIDER_FEE = '10%' as const;

export const CURRENT_CLIENT_FEE = '7.95';
export const CURRENT_SUPPORT_PROVIDER_FEE = '10';
